// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_g7-0";
export var headerCellHover = "_g7-1";
export var readCellContainer = "_g7-2";
export var unreadIndicator = "_g7-3";